import { render, staticRenderFns } from "./shhz.vue?vue&type=template&id=5829cc9c&scoped=true&"
import script from "./shhz.vue?vue&type=script&lang=js&"
export * from "./shhz.vue?vue&type=script&lang=js&"
import style0 from "./shhz.vue?vue&type=style&index=0&id=5829cc9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829cc9c",
  null
  
)

export default component.exports